class FeschdMountComparison extends HTMLElement {
  connectedCallback() {
    const dataElement = this.querySelector('[data-feschd-mount-comparison-data]');
    if (!dataElement) return;

    try {
      this.data = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    const selects = this.querySelectorAll('[data-slot-select]');
    this.slots = Array.from(selects).map((select) => select.value);

    selects.forEach((select) => {
      select.addEventListener('change', (event) => {
        const slotIndex = Number(event.currentTarget.dataset.slotSelect);
        this.handleChange(slotIndex, event.currentTarget.value);
      });
    });

    this.sentinel = this.querySelector('[data-sentinel]');
    this.stickyBar = this.querySelector('[data-sticky-bar]');

    if (this.sentinel && this.stickyBar && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.stickyBar.classList.toggle('is-stuck', !entry.isIntersecting);
        });
      });
      this.observer.observe(this.sentinel);
    }
  }

  handleChange(slotIndex, columnId) {
    this.slots[slotIndex] = columnId;
    this.render();
  }

  render() {
    this.slots.forEach((columnId, slotIndex) => {
      const column = this.data.columns[columnId];
      if (!column) return;

      this.querySelectorAll(`[data-slot-select="${slotIndex}"]`).forEach((select) => {
        select.value = columnId;
      });

      this.querySelectorAll(`[data-slot="${slotIndex}"] [data-field="image"]`).forEach((image) => {
        image.src = column.image;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      });

      this.querySelectorAll(`[data-slot="${slotIndex}"] [data-field="title"]`).forEach((element) => {
        element.textContent = column.title;
      });

      this.querySelectorAll(`[data-slot="${slotIndex}"] [data-field="offer"]`).forEach((element) => {
        element.textContent = column.offer || '';
      });

      this.querySelectorAll(`[data-slot="${slotIndex}"] [data-field="button"] a`).forEach((link) => {
        if (column.link) link.href = column.link;
      });

      this.querySelectorAll('[data-row-id]').forEach((row) => {
        const rowData = this.data.rows.find((candidate) => candidate.id === row.dataset.rowId);
        if (!rowData) return;

        const cell = row.querySelector(`[data-slot="${slotIndex}"] [data-field="value"]`);
        if (cell) cell.textContent = rowData.values[columnId] || '–';
      });
    });
  }
}

customElements.define('feschd-mount-comparison', FeschdMountComparison);
